module.exports = __webpack_public_path__ + "img/nav-02.6cad73ab.jpg";